import { n as e } from "./cn.CnaYSZq4.js";
//#region ../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
var t = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, n = e, r = (e, r) => (i) => {
	if (r?.variants == null) return n(e, i?.class, i?.className);
	let { variants: a, defaultVariants: o } = r, s = Object.keys(a).map((e) => {
		let n = i?.[e], r = o?.[e];
		if (n === null) return null;
		let s = t(n) || t(r);
		return a[e][s];
	}), c = i && Object.entries(i).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return n(e, s, r?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...i } = t;
		return Object.entries(i).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...o,
				...c
			}[t]) : {
				...o,
				...c
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), i?.class, i?.className);
};
//#endregion
export { r as t };
